import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  shell: {
    position: "sticky",
    top: 0,
    zIndex: 20,
    padding: "9px",
    borderRadius: 17,
    background:
      theme.palette.type === "dark"
        ? "rgba(13,22,38,.94)"
        : "rgba(255,255,255,.94)",
    border: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,.07)"
        : "#E8EDF5"
    }`,
    boxShadow:
      "0 12px 30px rgba(15,23,42,.07)",
    backdropFilter: "blur(16px)"
  },

  scroll: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    overflowX: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },

  item: {
    minHeight: 39,
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 13px",
    borderRadius: 11,
    border: "1px solid transparent",
    background: "transparent",
    color:
      theme.palette.type === "dark"
        ? "#94A3B8"
        : "#64748B",
    cursor: "pointer",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    fontSize: "0.71rem",
    fontWeight: 800,
    transition:
      "background .18s ease, color .18s ease, border-color .18s ease, transform .18s ease",

    "&:hover": {
      color:
        theme.palette.type === "dark"
          ? "#FFFFFF"
          : "#0F172A",
      background:
        theme.palette.type === "dark"
          ? "rgba(255,255,255,.045)"
          : "#F8FAFC",
      transform: "translateY(-1px)"
    }
  },

  active: {
    color: "#FFFFFF",
    borderColor: "rgba(96,165,250,.24)",
    background:
      "linear-gradient(135deg,#1D4ED8,#4F46E5)",
    boxShadow:
      "0 8px 18px rgba(37,99,235,.20)",

    "&:hover": {
      color: "#FFFFFF",
      background:
        "linear-gradient(135deg,#2563EB,#5B4FFF)"
    }
  },

  icon: {
    width: 25,
    height: 25,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    background: "rgba(255,255,255,.08)",
    fontSize: 13
  },

  badge: {
    minWidth: 20,
    height: 20,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 6px",
    borderRadius: 999,
    background: "rgba(255,255,255,.12)",
    fontSize: "0.59rem",
    fontWeight: 900
  }
}));

const items = [
  {
    id: "overview",
    label: "Overview",
    icon: "◫"
  },
  {
    id: "financial",
    label: "Financeiro",
    icon: "R$"
  },
  {
    id: "acquisition",
    label: "Aquisição",
    icon: "↗"
  },
  {
    id: "customers",
    label: "Clientes",
    icon: "◆"
  },
  {
    id: "ai",
    label: "Inteligência artificial",
    icon: "✦"
  },
  {
    id: "releases",
    label: "Releases",
    icon: "↗"
  },
  {
    id: "infrastructure",
    label: "Infraestrutura",
    icon: "▦"
  },
  {
    id: "settings",
    label: "Configurações",
    icon: "⚙"
  },
  {
    id: "announcements",
    label: "Comunicados",
    icon: "◉"
  }
];

const ControlCenterNav = ({
  activeModule,
  onChange,
  releaseCount = 0
}) => {
  const classes = useStyles();

  return (
    <nav
      className={classes.shell}
      aria-label="Módulos do Korax Control Center"
    >
      <div className={classes.scroll}>
        {items.map(item => {
          const active =
            activeModule === item.id;

          return (
            <button
              key={item.id}
              type="button"
              className={`${classes.item} ${
                active ? classes.active : ""
              }`}
              onClick={() => onChange(item.id)}
              aria-current={
                active ? "page" : undefined
              }
            >
              <span className={classes.icon}>
                {item.icon}
              </span>

              <span>{item.label}</span>

              {item.id === "releases" &&
                Number(releaseCount || 0) > 0 && (
                  <span className={classes.badge}>
                    {releaseCount}
                  </span>
                )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default ControlCenterNav;
